var App = App || {};

App.ResourcesBand = (function ($) {
    "use strict";

    function init() {
        const ResourcessBand = $(".component.component-resourcesband");
        $(".component.component-resourcesband").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".resourcesband-card", type: "animate__placeholder", stagger: 0 },
                { selector: ".featured-resourcesband-card", type: "animate__placeholder", stagger: 0 }
            ]
        });

        ResourcessBand.find(".resourcesband-card").each(function () {
            $(this).hover(
                function () {
                    $(this).addClass("animate__pulse");
                },
                function () {
                    $(this).removeClass("animate__pulse");
                }
            );
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ResourcesBand.init();
});